import { Alert } from '@/components/ui/alert';
import { Skeleton } from '@/components/ui/skeleton';

export const PendingVendorRequestsBannerSkeleton = () => (
  <Alert
    data-testid="pending-vendor-requests-banner-skeleton"
    className="grid-cols-[auto_1fr_auto] items-start gap-x-4 rounded-xl border-sky-200 bg-sky-100 p-4"
  >
    <Skeleton data-testid="banner-skeleton-icon" className="size-6.5 shrink-0 rounded-full" />
    <div className="col-start-2 space-y-2">
      <Skeleton data-testid="banner-skeleton-title" className="h-4 w-48" />
      <Skeleton data-testid="banner-skeleton-description" className="h-4 w-32" />
    </div>
    <div className="col-start-2 sm:col-start-3">
      <Skeleton data-testid="banner-skeleton-button" className="h-9 w-32" />
    </div>
  </Alert>
);
